export var ActionType;
(function (ActionType) {
    ActionType["EMI_ON_SAVED_CARD_TENURE_CHANGED"] = "EMI_ON_SAVED_CARD_TENURE_CHANGED";
})(ActionType || (ActionType = {}));
export const updateAdjustments = adjustments => {
    return {
        type: ActionType.EMI_ON_SAVED_CARD_TENURE_CHANGED,
        adjustments
    };
};
